import React from "react";
import styles from './Login.module.css';
import imgLogoLogin from '../../img/logo-login.94cc99f3.png';

//Services
import AuthService from '../../utils/auth/Auth.service';

const authService = new AuthService()

const Login = ({ history }) => {
  const handleFormSubmit = async(event) => {
    event.preventDefault();
    authService.login()
  }

  return (
    <React.Fragment>
      <div className={`${styles['jss1']} ${styles['jss4']} ${styles['jss9']}
        ${styles['jss13']} ${styles['jss18']} ${styles['bg-login']}`} style={{ 'height': '100vh' }}>

        <img src={imgLogoLogin} alt="pacífico" width="200" />
        <div>
          <p className={`${styles['jss98']} ${styles['jss106']} ${styles['jss121']}
              ${styles['fs-20']}`} id="login-title" style={{ color: 'white' }}>
            Web Solicitud Digital Vida
          </p>
          <br />
          <div className={`${styles['jss1']} ${styles['jss24']}`}>
            <div className={`${styles['jss2']} ${styles['jss41']}`}>
              <button className={`${styles['jss160']} ${styles['jss134']} ${styles['jss145']}
                  ${styles['jss147']} ${styles['jss159']}`}
                type="submit" id="login-button" onClick={handleFormSubmit}>
                <span className={styles['jss135']}>Entrar aquí</span>
                <span className={styles['jss163']}></span>
              </button>
            </div>
          </div>
        </div>

        {process.env.REACT_APP_AMBIENTE !== 'PRODUCCION'
          ? <div style={{position: 'absolute', bottom: 0, right: 0, opacity: 0.15}}>
            {process.env.REACT_APP_AMBIENTE}
          </div>
          : null
        }
      </div>
    </React.Fragment>
  )
}

export default Login;